import "./Styles/listing-inputs.scss";
import "react-toggle/style.css";
import Pagination from "../../Components/Pagination/pagination";

import config from "../../app.json";
import axios from "axios";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "../../Components/AlertComponent";
import InputCard from "../../Components/InputCard/input-card";

function ListingInputs() {
  let navigate = useNavigate();
  const [inputList, setInputList] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const itemsPerPage = 12;


  const fetchInputs = () => {
    axios
      .post(config.API + "/api/Input/getInputs", { 
        page: currentPage,
        perPage: itemsPerPage,
      })
      .then((res) => {
        if (res.status === 200 && res.data) {

          if (res.data.$values.length) {
            setTotalItems(res.data.total);
          } else {
            setTotalItems(0);
          }

          setInputList(res.data.$values);
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error ||
            error?.response?.data?.message ||
            error?.message,
          { icon: `error` }
        );
      });
  };

  useEffect(() => {
    fetchInputs();
  }, [0]);

  const handleNewInput = () => {
    return navigate("/newInput", { replace: false });
  };

  useEffect(() => {
    const totalPagesCalculated = Math.ceil(totalItems / itemsPerPage);
    setTotalPages(totalPagesCalculated);
  }, [totalItems]);

  useEffect(() => {
    fetchInputs();
  }, [currentPage]);

  const nextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const prevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const paginationElement = inputList && inputList.length ? (
    <div className="pagination-container">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNextPage={nextPage}
        onPrevPage={prevPage}
      />
    </div>
  ) : null;

  return (
    <Row>
      <Col className="col-md-11">
      <Row>
          <Col className="col-md-12 mt-4 mb-3">
            <Button className="add-new-btn" onClick={handleNewInput}>
              Add new
            </Button>
          </Col>
        </Row>
        <Row className="listing-inputs-container">
          {inputList?.map((x, index) => (
            <Col className="col-md-3">
              <InputCard
                {...x}
                index={index}
                deleteApiPath={x.attached ? `` : `/api/Input/deleteInput`}
                attached={x.attached}
                onDelete={fetchInputs}
              />
            </Col>
          ))}
         
          {(!inputList || !inputList.length) &&  
          <Col className="col-md-6">
            <div className="empty-state"><div className="empty-state-card">There are no registered inputs.</div></div>
          </Col>
          }

          {paginationElement}
        </Row>
      </Col>
    </Row>
  );
}

export default ListingInputs;
